/* ==========================================================
   CRO - menu rehecho como la referencia, en las dos pantallas.
   set. 2026

   Arma el menu de genius-originals-concept sobre la navegacion de
   Symmetry: en celular dentro del cajon, en escritorio como fila
   horizontal con panel a lo ancho. Los estilos van en gs-menu.css.

   ----------------------------------------------------------
   QUE HACE, EN ORDEN
   ----------------------------------------------------------
   EN CELULAR
   1. Espera a que exista .mobile-navigation-drawer.
   2. Reemplaza .navigation--main -la lista de 5 enlaces del tema- por
      los cuatro grupos desplegables.
   3. Deja intacto .mobile-navigation-drawer__footer, que trae el
      selector de idioma y los iconos sociales del tema.

   EN ESCRITORIO
   4. Reemplaza el ul.navigation__tier-1 de .navigation--left por una
      fila de cuatro botones.
   5. Cuelga los cuatro paneles de .pageheader, que ya viene con
      position:relative y ocupa el ancho completo: asi el panel cae por
      debajo de la cabecera y de lado a lado, como en la referencia.

   EN LAS DOS
   6. Engancha el acordeon: abrir uno cierra los demas, igual que la
      referencia (su script.js hace closeDropdowns(open ? item : null)).
      En escritorio se suman dos salidas que el panel necesita por tapar
      contenido: tocar fuera y la tecla Escape.

   ----------------------------------------------------------
   POR QUE SE ARMA CON JAVASCRIPT Y NO EN LIQUID
   ----------------------------------------------------------
   El menu de Symmetry se genera en sections/header.liquid, 36633 bytes.
   Tocarlo obliga a reescribir el archivo entero y deja el tema atado a
   esta version. Armandolo aca, todo el menu nuevo vive en dos archivos
   propios; para volver atras se quitan las dos lineas de theme.liquid.

   COSTO REAL DE ESA DECISION: el menu se dibuja despues de que carga el
   JavaScript. Si el archivo no carga, el cliente ve el menu original de
   Symmetry, que sigue funcionando. Degrada, no se rompe.

   ----------------------------------------------------------
   LOS DESTINOS SON REALES, NO INVENTADOS
   ----------------------------------------------------------
   Las 12 rutas que usa la referencia se comprobaron una por una contra
   la tienda y las 12 responden 200. Estan escritas tal cual.

   DOS EXCEPCIONES, a proposito:
   "Nuestros materiales" y "Tienda fisica" apuntan en la referencia a
   anclas de su propia pagina -#materiales y #tienda- que en la tienda
   no existen: no hay /pages/materiales ni /pages/nuestra-tienda -las dos
   dan 404-. Aca van al inicio, que es donde viven esas secciones hoy.
   Si se crean esas paginas, cambiar las dos rutas de abajo.

   ----------------------------------------------------------
   OJO CON DOS COSAS
   ----------------------------------------------------------
   1. El logo NO esta escrito a mano: se lee del header de la pagina en
      el momento de armar. Asi, si se cambia el logo en el tema, el menu
      lo sigue solo. Si no lo encuentra, no pone imagen y no falla.

   2. En celular hay DOS salidas (22 set.): la X arriba a la derecha,
      junto al logo, y tocar la franja de pagina que queda a la derecha
      del cajon -el cajon ya no ocupa toda la pantalla-. Antes habia un
      "Cerrar" pegado abajo; anderson lo quito porque interrumpia el menu.
      Al reemplazar .navigation--main se pierde la X que traia Symmetry,
      por eso la X se dibuja aca.
   ========================================================== */

(function () {
  'use strict';

  var INICIO = '/';

  // Cantidad de resenas de Judge.me. La pone theme.liquid en la etiqueta
  // <script> de este archivo -data-resenas- desde el metacampo
  // shop.metafields.judgeme.all_reviews_count, que Judge.me actualiza solo
  // con cada resena nueva. Antes el numero estaba escrito a mano ("411") y
  // se quedo atras: la ficha de producto ya decia 415. Un numero concreto
  // se lee como medido; si no coincide con el de la ficha, resta confianza.
  // document.currentScript solo existe mientras corre este bloque, por eso
  // se lee aca arriba. Sin numero valido el enlace dice "Testimonios".
  var RESENAS = (function () {
    var s = document.currentScript;
    var n = s ? s.getAttribute('data-resenas') : '';
    return /^[0-9]+$/.test(n || '') && n !== '0' ? n : '';
  })();

  var GRUPOS = [
    {
      id: 'catalogo',
      titulo: 'Catálogo',
      oscuro: false,
      kicker: 'Comprar',
      encabezado: 'Para cada forma<br>de ser tú.',
      verTodo: { texto: 'Ver todo el catálogo →', url: '/collections/frontpage' },
      // Sin descripcion debajo de cada destino (13 set.): en un menu la
      // gente busca una palabra, no lee. "Microfibra" salio porque esa linea
      // se descontinua. Su lugar lo toma "Camisetas y medias", coleccion que
      // junta las camisetas de adulto y de nino con las medias: por separado
      // eran colecciones de 1 a 3 productos, y un enlace a una pagina casi
      // vacia promete surtido que no hay. La columna pasa de "Por estilo" a
      // "Por tipo" porque camisetas y medias son otra prenda, no un estilo.
      //
      // 15 set.: los tres destinos de "Por tipo" ya no van a colecciones
      // sueltas, sino a Caballeros con su chip marcado (mismo enlace que
      // hace el chip). Asi el cliente cae en la pagina de catalogo -con sus
      // filtros, su barra de precio y los otros tipos a un toque- en vez de
      // una coleccion aparte desde la que hay que volver atras para cambiar
      // de idea. El texto del filtro va codificado igual que en el chip.
      listas: [
        {
          rotulo: 'Por colección',
          items: [
            { nombre: 'Caballeros', url: '/collections/frontpage' },
            { nombre: 'Damas', url: '/collections/coleccion-damas' },
            { nombre: 'Niños', url: '/collections/coleccion-ninos' }
          ]
        },
        {
          rotulo: 'Por tipo',
          items: [
            { nombre: 'Estampados', url: '/collections/frontpage?filter.p.m.custom.estilo=Estampado' },
            { nombre: 'Básicos', url: '/collections/frontpage?filter.p.m.custom.estilo=B%C3%A1sico' },
            { nombre: 'Camisetas y medias', url: '/collections/frontpage?filter.p.m.custom.estilo=Camisetas+y+medias' }
          ]
        }
      ],
      destacado: {
        titulo: 'Samurai Originals',
        nota: 'Conoce al guerrero →',
        url: '/products/boxer-samurai-para-hombre-algodon-peruano-genius-70263',
        // Foto en Contenido > Archivos: menu-catalogo-samurai-closeup.jpg
        // (1200x1000). NO borrarla de ahi: este enlace esta escrito a mano
        // y el recuadro del menu quedaria vacio en todos los temas.
        imagen: '//cdn.shopify.com/s/files/1/0608/3824/8537/files/menu-catalogo-samurai-closeup.jpg?v=1789331694&width=800'
      }
    },
    {
      id: 'originals',
      titulo: 'Originals',
      oscuro: true,
      kicker: 'Genius Originals',
      encabezado: 'La historia empieza<br>antes de vestirlo.',
      // 22 set.: iba a /collections/lo-nuevo, que mezcla estampados con
      // basicos y slips: quien pedia Originals caia en "lo ultimo que
      // ingreso". Ahora va a la coleccion Originals (manual, 20 disenos).
      verTodo: { texto: 'Descubrir la colección →', url: '/collections/originals' },
      // Fotos en Contenido > Archivos: menu-originals-samurai.jpg,
      // menu-originals-predator.jpg y menu-originals-huevos.jpg, recortes
      // cuadrados del estampado. NO borrarlas de ahi: estos enlaces estan
      // escritos a mano y las cajas volverian a quedar sin foto.
      historias: [
        { n: '01', nombre: 'Samurai', nota: 'Disciplina y honor', url: '/products/boxer-samurai-para-hombre-algodon-peruano-genius-70263', foto: '//cdn.shopify.com/s/files/1/0608/3824/8537/files/menu-originals-samurai.jpg?v=1789332620&width=800' },
        { n: '02', nombre: 'Predator', nota: 'El cazador silencioso', url: '/products/boxer-predator-para-hombre-algodon-peruano-genius', foto: '//cdn.shopify.com/s/files/1/0608/3824/8537/files/menu-originals-predator.jpg?v=1789332620&width=800' },
        { n: '03', nombre: 'Huevos', nota: 'Humor con carácter', url: '/products/huevos-70261', foto: '//cdn.shopify.com/s/files/1/0608/3824/8537/files/menu-originals-huevos.jpg?v=1789332619&width=800' }
      ]
    },
    {
      id: 'packs',
      titulo: 'Packs y ofertas',
      oscuro: false,
      kicker: 'Elige más',
      encabezado: 'Arma tu rotación.',
      // 19 set.: "Hasta 30% OFF" iba a /collections/hasta-30-off, coleccion
      // manual con la plantilla vieja que se desactualizaba sola: tenia 41
      // productos contra 45 en oferta en Caballeros, y 3 de los suyos ya no
      // tenian descuento. Ahora va a Caballeros con el chip Ofertas marcado,
      // que se arma solo con el metacampo en_oferta.
      ofertas: [
        { nota: 'Combina tus favoritos', nombre: 'Pack Genius', accion: 'Armar pack ↗', url: '/pages/pack', tono: 'azul' },
        { nota: 'Selección especial', nombre: 'Hasta 30% OFF', accion: 'Ver ofertas ↗', url: '/collections/frontpage?filter.p.m.custom.en_oferta=1', tono: 'naranja' },
        { nota: 'Recién llegados', nombre: 'Lo más nuevo', accion: 'Explorar ↗', url: '/collections/lo-nuevo', tono: '' }
      ]
    },
    {
      id: 'genius',
      titulo: 'Conoce Genius',
      oscuro: false,
      kicker: 'Desde hace más de 14 años',
      encabezado: 'Comodidad con<br>personalidad.',
      listas: [
        {
          rotulo: 'La marca',
          items: [
            { nombre: 'Nuestros materiales', url: INICIO },
            { nombre: RESENAS ? RESENAS + ' testimonios' : 'Testimonios', url: '/pages/testimonios' }
          ]
        },
        {
          rotulo: 'Te ayudamos',
          items: [
            { nombre: 'Guía de tallas', url: '/pages/guia-de-tallas' },
            { nombre: 'Tienda física', url: INICIO }
          ]
        }
      ],
      cita: { texto: '“La ropa interior también puede contar quién eres.”', firma: 'Manifiesto Genius' }
    }
  ];

  function esc(t) {
    return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function lista(l) {
    var h = '<div class="gs-menu__links"><p>' + esc(l.rotulo) + '</p>';
    l.items.forEach(function (it) {
      h += '<a href="' + esc(it.url) + '"><b>' + esc(it.nombre) + '</b>' +
           (it.nota ? '<small>' + esc(it.nota) + '</small>' : '') + '</a>';
    });
    return h + '</div>';
  }

  function cuerpo(g) {
    var h = '<div class="gs-menu__intro"><p class="gs-menu__kicker">' + esc(g.kicker) + '</p>';
    h += '<h2>' + g.encabezado + '</h2>';
    if (g.verTodo) {
      h += '<a class="gs-menu__vertodo" href="' + esc(g.verTodo.url) + '">' + esc(g.verTodo.texto) + '</a>';
    }
    h += '</div>';

    (g.listas || []).forEach(function (l) { h += lista(l); });

    (g.historias || []).forEach(function (s) {
      var clase = 'gs-menu__historia' + (s.foto ? ' gs-menu__historia--foto' : '');
      var fondo = s.foto ? ' data-fondo="' + esc(s.foto) + '"' : '';
      h += '<a class="' + clase + '"' + fondo + ' href="' + esc(s.url) + '"><span>' + esc(s.n) + '</span>' +
           '<b>' + esc(s.nombre) + '</b><small>' + esc(s.nota) + '</small></a>';
    });

    (g.ofertas || []).forEach(function (o) {
      var clase = 'gs-menu__oferta' + (o.tono ? ' gs-menu__oferta--' + o.tono : '');
      h += '<a class="' + clase + '" href="' + esc(o.url) + '"><small>' + esc(o.nota) + '</small>' +
           '<b>' + esc(o.nombre) + '</b><span>' + esc(o.accion) + '</span></a>';
    });

    if (g.destacado) {
      h += '<a class="gs-menu__feature" href="' + esc(g.destacado.url) + '">' +
           '<img data-src="' + esc(g.destacado.imagen) + '" alt="' + esc(g.destacado.titulo) + '">' +
           '<span><b>' + esc(g.destacado.titulo) + '</b><small>' + esc(g.destacado.nota) + '</small></span></a>';
    }

    if (g.cita) {
      h += '<div class="gs-menu__cita"><p>' + esc(g.cita.texto) + '</p><span>' + esc(g.cita.firma) + '</span></div>';
    }

    return h;
  }

  // Las fotos del menu se piden recien al abrir su panel. Antes iban con
  // src en el HTML y el celular las descargaba al cargar CUALQUIER pagina,
  // aunque el cliente nunca abriera el menu: el loading="lazy" no lo
  // frenaba porque el cajon esta pegado a la pantalla. data-src y
  // data-fondo guardan la direccion hasta que se abre el panel.
  function cargarFotos(panel) {
    if (!panel) return;
    [].forEach.call(panel.querySelectorAll('img[data-src]'), function (img) {
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
    });
    [].forEach.call(panel.querySelectorAll('[data-fondo]'), function (el) {
      el.style.backgroundImage = 'url("' + el.getAttribute('data-fondo') + '")';
      el.removeAttribute('data-fondo');
    });
  }

  function armar() {
    var cajon = document.querySelector('.mobile-navigation-drawer');
    if (!cajon || cajon.querySelector('.gs-menu')) return;

    var vieja = cajon.querySelector('.navigation--main');
    if (!vieja) return;

    var logo = document.querySelector('.logo img, .logo-area img');
    // gs-m es la clase que comparten la raiz de celular y cada panel de
    // escritorio. Las piezas internas -antetitulo, listas, fotos, cita-
    // se estilan una sola vez contra .gs-m y sirven para las dos.
    var h = '<div class="gs-menu gs-m">';

    // Fila de arriba: logo a la izquierda y X a la derecha, donde el
    // pulgar y la costumbre la buscan. Si no hay logo, un span vacio
    // mantiene la X a la derecha.
    h += '<div class="gs-menu__marca">' +
         (logo && logo.getAttribute('src')
           ? '<img src="' + esc(logo.getAttribute('src')) + '" alt="Genius Underwear">'
           : '<span></span>') +
         '<button class="gs-menu__x" type="button" aria-label="Cerrar menú">' +
         '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true">' +
         '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button></div>';

    GRUPOS.forEach(function (g) {
      var panel = 'gs-menu__panel' + (g.oscuro ? ' gs-menu__panel--oscuro' : '');
      h += '<div class="gs-menu__grupo">' +
           '<button class="gs-menu__trigger" type="button" aria-expanded="false" aria-controls="gs-menu-' + g.id + '">' +
           esc(g.titulo) + ' <span aria-hidden="true">⌄</span></button>' +
           '<div class="' + panel + '" id="gs-menu-' + g.id + '" aria-hidden="true">' +
           '<div class="gs-menu__inner">' + cuerpo(g) + '</div></div></div>';
    });

    h += '</div>';

    vieja.innerHTML = h;
    enganchar(cajon);
  }

  function enganchar(cajon) {
    var grupos = [].slice.call(cajon.querySelectorAll('.gs-menu__grupo'));

    function fijar(grupo, abrir) {
      grupos.forEach(function (g) {
        var esEste = g === grupo;
        var abierto = esEste && abrir;
        var t = g.querySelector('.gs-menu__trigger');
        var p = g.querySelector('.gs-menu__panel');
        t.setAttribute('aria-expanded', String(abierto));
        p.setAttribute('aria-hidden', String(!abierto));
        p.classList.toggle('esta-abierto', abierto);
        if (abierto) cargarFotos(p);
      });
    }

    grupos.forEach(function (g) {
      var t = g.querySelector('.gs-menu__trigger');
      t.addEventListener('click', function () {
        fijar(g, t.getAttribute('aria-expanded') !== 'true');
      });
    });

    var cerrar = cajon.querySelector('.gs-menu__x');
    if (cerrar) {
      cerrar.addEventListener('click', function () {
        // Se reusa el mismo boton del tema para cerrar, en vez de tocar
        // las clases del body a mano: asi el cajon se cierra con la misma
        // transicion y el mismo estado que usa Symmetry.
        var x = cajon.querySelector('a.mobile-nav-toggle') ||
                document.querySelector('button.mobile-nav-toggle');
        if (x) x.click();
      });
    }
  }

  function armarEscritorio() {
    var cab = document.querySelector('.pageheader');
    if (!cab || cab.querySelector('.gs-nav-esc')) return;

    var lista = cab.querySelector('.navigation--left .navigation__tier-1');
    if (!lista) return;

    var botones = '<ul class="gs-nav-esc">';
    var paneles = '<div class="gs-nav-paneles">';

    GRUPOS.forEach(function (g) {
      botones += '<li><button class="gs-menu__trigger gs-nav-esc__btn" type="button" ' +
                 'aria-expanded="false" aria-controls="gs-esc-' + g.id + '">' +
                 esc(g.titulo) + ' <span aria-hidden="true">⌄</span></button></li>';

      var clase = 'gs-menu__panel gs-nav-panel gs-m' + (g.oscuro ? ' gs-menu__panel--oscuro' : '');
      paneles += '<div class="' + clase + '" id="gs-esc-' + g.id + '" aria-hidden="true">' +
                 '<div class="gs-menu__inner">' + cuerpo(g) + '</div></div>';
    });

    botones += '</ul>';
    paneles += '</div>';

    // outerHTML y no innerHTML: se cambia el ul entero, no su contenido.
    // theme.inlineNavigationCheck busca .navigation__item ahi dentro y ya
    // no los encuentra, pero su codigo lo tiene guardado con un if: no
    // falla, simplemente no hace el calculo de ancho que ya no aplica.
    lista.outerHTML = botones;
    cab.insertAdjacentHTML('beforeend', paneles);

    engancharEscritorio(cab);
  }

  function engancharEscritorio(cab) {
    var botones = [].slice.call(cab.querySelectorAll('.gs-nav-esc__btn'));

    function fijar(boton, abrir) {
      botones.forEach(function (b) {
        var abierto = (b === boton) && abrir;
        var p = document.getElementById(b.getAttribute('aria-controls'));
        b.setAttribute('aria-expanded', String(abierto));
        if (p) {
          p.setAttribute('aria-hidden', String(!abierto));
          p.classList.toggle('esta-abierto', abierto);
          if (abierto) cargarFotos(p);
        }
      });
      document.body.classList.toggle('gs-nav-abierto', abrir);
    }

    botones.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        fijar(b, b.getAttribute('aria-expanded') !== 'true');
      });
    });

    // El panel tapa la pagina, asi que necesita salidas: tocar fuera y
    // Escape. Sin esto el unico modo de cerrarlo seria volver a tocar el
    // mismo boton, que es justo el que queda debajo del panel.
    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('.gs-nav-panel')) fijar(null, false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') fijar(null, false);
    });
  }

  // El cajon puede dibujarse despues de la carga: Symmetry lo arma desde
  // una plantilla. Por eso se intenta al cargar, al tocar el boton de
  // menu y, como red, con un observador del DOM que se apaga solo.
  function arranque() {
    armar();
    armarEscritorio();

    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.mobile-nav-toggle')) {
        setTimeout(armar, 0);
      }
    }, true);

    var obs = new MutationObserver(function () {
      if (document.querySelector('.mobile-navigation-drawer .gs-menu') &&
          document.querySelector('.pageheader .gs-nav-esc')) {
        obs.disconnect();
        return;
      }
      armar();
      armarEscritorio();
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranque);
  } else {
    arranque();
  }
})();